<template>
  <div id="app">
    <notifications position="top right"></notifications>
    <cookie-law theme="boxx"></cookie-law>
    <fade-transition origin="center" mode="out-in" :duration="200">
      <router-view name="header"></router-view>
    </fade-transition>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="200">
        <router-view :key="$route.fullPath" />
      </fade-transition>
    </main>
    <fade-transition origin="center" mode="out-in" :duration="200">
      <router-view name="footer"></router-view>
    </fade-transition>
  </div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    FadeTransition,
    CookieLaw
  }
};
</script>
